
// src/App.jsx
import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "animate.css";

import { initGA, logPageView } from "./utils/analytics";
// import { canUseAnalytics } from "./utils/consent";
// import CookieConsent from "./components/CookieConsent";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";

import Layout from "./components/Layout";              // <- mantém a tua pasta
import RotaPrivada from "./components/RotaPrivada";
import AdminLayout from "./layouts/AdminLayout";
import { initCart } from "./cart/cart-utils";
// import CheckoutResult from "./pages/CheckoutResult";
import LandingFromPackagePure from "./pages/LandingFromPackagePure";
import LandingLayout from "./landing/layouts/LandingLayout";
import PoliticaEntrega from "./pages/PoliticaEntrega";
import EliminarDados from "./pages/EliminarDados";
// import Conta from "./pages/Conta.old";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Conta from "./pages/Conta/Conta";
// import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade";
import PoliticaCookies from "./pages/PoliticaCookies";

const Home = lazy(() => import("./pages/Home"));
const Login = lazy(() => import("./pages/Login"));
const Livro = lazy(() => import("./pages/Livro"));
const CartPage = lazy(() => import("./pages/CartPage"));
const ProductPage = lazy(() => import("./pages/ProductPage"));
const YouTube = lazy(() => import("./pages/YouTube"));
const TermosCondicoes = lazy(() => import("./pages/TermosCondicoes"));
const CheckoutPage = lazy(() => import("./pages/CheckoutPage"));
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard"));
const AdminPedidos = lazy(() => import("./pages/admin/AdminPedidos"));
const AdminProdutos = lazy(() => import("./pages/admin/AdminProdutos"));
const AdminClientes = lazy(() => import("./pages/admin/AdminClientes"));
const AdminConfig = lazy(() => import("./pages/admin/AdminConfig"));
const ServiceLanding = lazy(() => import("./pages/ServiceLanding"));
const LandingLegacy = lazy(() => import("./pages/LandingLegacy"));
const LandingAds = lazy(() => import("./landing/pages/LandingAds"));

// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK || "");
const Fallback = () => <div className="page-skel" style={{ height: 120 }} />;

/* ----- Classe pode ficar, mas NÃO usar hooks aqui ----- */
class ErrorBoundary extends React.Component {
  constructor(p) { super(p); this.state = { hasError: false }; }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(err, info) { /* opcional: log */ }
  render() {
    if (this.state.hasError) {
      return (
        <div className="container py-5">
          <h1 className="h5">Ops! Houve um problema a carregar esta página.</h1>
          <p className="text-muted">Por favor, tente refrescar ou voltar atrás.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

/* ----- AQUI SIM: Componente de função com hooks ----- */
function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

export default function App() {
  useEffect(() => {
    initGA();
    if (typeof requestIdleCallback === "function") {
      // useEffect(() => {
      //   // Só inicializa GA se já houver consentimento analítico
      //   if (canUseAnalytics()) initGA();
      //   if (typeof requestIdleCallback === "function") {
      requestIdleCallback(() => initCart(), { timeout: 300 });
    } else {
      setTimeout(() => initCart(), 0);
    }
  }, []);

  return (
    <Router>
      {/* PageTracker precisa estar DENTRO do Router */}
      <PageTracker />
      <ErrorBoundary>
        <Routes>
          {/* --- Site com Layout --- */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Suspense fallback={<Fallback />}><Home /></Suspense>} />
            <Route path="login" element={<Suspense fallback={<Fallback />}><Login /></Suspense>} />
            <Route path="register" element={<Suspense fallback={<Fallback />}><Register /></Suspense>} />
            <Route path="recuperar-senha" element={<Suspense fallback={<Fallback />}><ForgotPassword /></Suspense>} />
            <Route path="reset-password/:token" element={<Suspense fallback={<Fallback />}><ResetPassword /></Suspense>} />


            <Route path="livros" element={<Suspense fallback={<Fallback />}><Livro /></Suspense>} />
            <Route path="carrinho" element={<Suspense fallback={<Fallback />}><CartPage /></Suspense>} />
            <Route path="produto/:id" element={<Suspense fallback={<Fallback />}><ProductPage /></Suspense>} />
            <Route path="youtube" element={<Suspense fallback={<Fallback />}><YouTube /></Suspense>} />
            <Route path="TermosCondicoes" element={<Suspense fallback={<Fallback />}><TermosCondicoes /></Suspense>} />
            <Route path="landing-pura" element={<Suspense fallback={<Fallback />}><LandingFromPackagePure /></Suspense>} />
            <Route path="terapias/:slug" element={<Suspense fallback={<Fallback />}><ServiceLanding /></Suspense>} />
            <Route path="landing-legacy" element={<Suspense fallback={<Fallback />}><LandingLegacy /></Suspense>} />
            <Route path="politica-entrega" element={<Suspense fallback={<Fallback />}><PoliticaEntrega /></Suspense>} />
            <Route path="eliminar-dados" element={<Suspense fallback={<Fallback />}><EliminarDados /></Suspense>} />
            <Route path="politica-de-privacidade" element={<Suspense fallback={<Fallback />}><PoliticaPrivacidade /></Suspense>} />
            <Route path="politica-de-cookies" element={<Suspense fallback={<Fallback />}><PoliticaCookies /></Suspense>} />

            <Route path="conta" element={<Suspense fallback={<Fallback />}><Conta /></Suspense>} />
            <Route path="conta/encomendas" element={<Suspense fallback={<Fallback />}><Conta /></Suspense>} />

            <Route path="checkout/sucesso" element={<CheckoutSuccess />} />
            <Route path="checkout/erro" element={<CheckoutSuccess />} />
          </Route>

          {/* --- Checkout FORA do Layout --- */}
          <Route
            path="/checkout"
            element={
              <Suspense fallback={<Fallback />}>
                <CheckoutPage />
              </Suspense>
            }
          />
          <Route
            path="/checkout/:id"
            element={
              <Suspense fallback={<Fallback />}>
                <CheckoutPage />
              </Suspense>
            }
          />
          {/* Landing sem nav / layout do site */}
          <Route
            path="/landing-ads"
            element={
              <Suspense fallback={<Fallback />}>
                <LandingAds />
              </Suspense>
            }
          />


          {/* --- Admin, landing-ads, etc... (como tens) --- */}

          {/* fallback global (último) */}
          <Route path="*" element={<Navigate to="/livros" replace />} />
        </Routes>

      </ErrorBoundary>
    </Router>
  );
}
